import { FC } from 'react';
import { css } from '@emotion/react';
import { spacing, colors } from '../../../styles';

interface ParsedToolOutput {
  type?: string;
  status?: string;
  message?: string;
  [key: string]: any;
}

interface ToolRendererProps {
  toolName: string;
  output: ParsedToolOutput;
  isLoading?: boolean;
}

export const OptionsRenderer: FC<ToolRendererProps> = ({ output, isLoading }) => {
  if (isLoading) {
    return (
      <div
        css={css`
          font-size: 14px;
          color: ${colors.silver};
        `}
      >
        Analyzing options...
      </div>
    );
  }

  const content = typeof output === 'string' ? output : output.content || '';
  if (content.includes('call') || content.includes('put') || content.includes('option')) {
    return (
      <div
        css={css`
          font-size: 14px;
          color: ${colors.liquorice};
          line-height: 1.4;

          html[data-theme='dark'] & {
            color: ${colors.sugar};
          }
        `}
      >
        <div
          css={css`
            margin-bottom: ${spacing.centi};
          `}
        >
          Options analysis generated
        </div>
        <div
          css={css`
            font-size: 12px;
            color: ${colors.silver};
          `}
        >
          {content.split('\n')[0].replace(/[#*]/g, '').trim()}
        </div>
      </div>
    );
  }

  return (
    <div
      css={css`
        font-size: 14px;
        color: ${colors.silver};
      `}
    >
      Options analysis completed
    </div>
  );
};
